export default {
  creationTime: "Erstellzeit",
  creationDate: "Erstelldatum",
  measurementDate: "Messzeitpunkt",
  last24Hours: "Letzte 24 Stunden",
  last3Days: "Letzte 3 Tage",
  lastWeek: "Letzte Woche",
  last2Weeks: "Letzte 2 Woche",
  lastMonth: "Letzter Monat",
  lastYear: "Letztes Jahr",
  date: "date",
  hours: "hours",
  minutes: "minutes",
  hour: "hour",
  minute: "minute",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  formats:{
    date: "dd.MM.yyyy",
    time: "HH:mm",
    dateTime: "dd.MM.yyyy HH:mm",
    dateTimeWithSeconds: "dd.MM.yyyy HH:mm:ss",
  },
  timeBucket: {
    tenMin: "10 min",
    oneHour: "1 Stunde",
    sixHours: "6 Stunden",
    twelveHours: "12 Stunden",
    twentyfourHours: "24 Stunden",
  },
};
